import React from 'react';
import { getOnboardingUrl } from "../../utils/portalUrl";
import { useTranslation } from 'react-i18next';
import { FaLightbulb, FaUsers, FaSyncAlt, FaBullseye, FaGlobe } from 'react-icons/fa';
import Navbar from '../../Components/Navbar/Navbar';
import Footer from '../../Components/Footer/Footer';
import SEO from '../../Components/SEO/SEO';
import { ABOUT_META } from '../../seo/pageMeta';
import styles from './AboutPage.module.css';

const VALUES = [
  { keyPrefix: 'v1', Icon: FaLightbulb, color: '#f59e0b' },
  { keyPrefix: 'v2', Icon: FaUsers,     color: '#203052' },
  { keyPrefix: 'v3', Icon: FaSyncAlt,   color: '#10b981' },
];

const STATS = [
  { valKey: 'stat1Value', labelKey: 'stat1Label' },
  { valKey: 'stat2Value', labelKey: 'stat2Label' },
  { valKey: 'stat3Value', labelKey: 'stat3Label' },
];

const AboutPage = () => {
  const { t } = useTranslation();
  return (
    <div className={styles.page}>
      <SEO {...ABOUT_META} />
      <Navbar />

      {/* Hero */}
      <section className={styles.hero}>
        <div className="container">
          <span className={styles.heroBadge} data-aos="fade-up">{t('aboutPage.badge')}</span>
          <h1 data-aos="fade-up" data-aos-delay="60">{t('aboutPage.heroTitle')}</h1>
          <p data-aos="fade-up" data-aos-delay="120">{t('aboutPage.heroSubtitle')}</p>
          <a
            href={getOnboardingUrl("cta")}
            className={styles.heroCta}
            data-aos="fade-up"
            data-aos-delay="180"
          >
            {t('aboutPage.cta')}
          </a>
        </div>
      </section>

      {/* Stats strip */}
      <section className={styles.statsStrip}>
        <div className="container">
          <div className={styles.statsGrid}>
            {STATS.map(({ valKey, labelKey }) => (
              <div key={valKey} className={styles.statItem}>
                <span className={styles.statValue}>{t(`aboutPage.${valKey}`)}</span>
                <span className={styles.statLabel}>{t(`aboutPage.${labelKey}`)}</span>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Mission / Vision */}
      <section className={styles.missionSection}>
        <div className="container">
          <div className={styles.missionGrid}>
            <div className={styles.missionCard} data-aos="fade-up">
              <div className={styles.missionAccent} style={{ background: '#FE4E00' }} />
              <div className={styles.missionIconWrap} style={{ background: '#FE4E0015', color: '#FE4E00' }}>
                <FaBullseye />
              </div>
              <h2>{t('aboutPage.missionTitle')}</h2>
              <p>{t('aboutPage.missionBody')}</p>
            </div>
            <div className={styles.missionCard} data-aos="fade-up" data-aos-delay="100">
              <div className={styles.missionAccent} style={{ background: '#203052' }} />
              <div className={styles.missionIconWrap} style={{ background: '#20305215', color: '#203052' }}>
                <FaGlobe />
              </div>
              <h2>{t('aboutPage.visionTitle')}</h2>
              <p>{t('aboutPage.visionBody')}</p>
            </div>
          </div>
        </div>
      </section>

      {/* Values */}
      <section className={styles.valuesSection}>
        <div className="container">
          <h2 data-aos="fade-up">{t('aboutPage.valuesTitle')}</h2>
          <div className={styles.valuesGrid}>
            {VALUES.map(({ keyPrefix, Icon, color }, i) => (
              <div key={keyPrefix} className={styles.valueCard} data-aos="fade-up" data-aos-delay={i * 80}>
                <div className={styles.valueIcon} style={{ backgroundColor: color + '18', color }}><Icon /></div>
                <h3>{t(`aboutPage.${keyPrefix}Title`)}</h3>
                <p>{t(`aboutPage.${keyPrefix}Body`)}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className={styles.ctaSection}>
        <div className="container">
          <h2>{t('aboutPage.ctaTitle')}</h2>
          <p>{t('aboutPage.ctaSubtitle')}</p>
          <a href={getOnboardingUrl("cta")} className={styles.ctaButton}>
            {t('aboutPage.cta')}
          </a>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default AboutPage;
